import { UnityHubLayout } from 'App/components/UnityHub'
import { EventsInfo } from 'App/components/Events/EventsInfo'

export const PublicEventInfo = () => (
  <UnityHubLayout>
    <EventsInfo />
  </UnityHubLayout>
)
